import type { ReactNode } from "react";
import "./ToggleButtonGroup.scss";

export type ToggleButtonGroupDirection = "horizontal" | "vertical";

interface ToggleButtonGroupProps {
  direction: "horizontal" | "vertical";
  children: ReactNode;
}

export default function ToggleButtonGroup(
  props: ToggleButtonGroupProps,
): ReactNode {
  return (
    <div className={`toggle-button-group direction-${props.direction}`}>
      {props.children}
    </div>
  );
}
